import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2b384778"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))

import router from "@/router";
import GlobalHeader from "@/layouts/GlobalHeader.vue";
import { useRoute } from "vue-router";
import { ref, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const onClickMenuItem = (path: string) => {
  router.push(path);
};

const route = useRoute();
const hostPath = ref<string>(route.path);
watchEffect(() => {
  hostPath.value = route.path;
});

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_icon_user = _resolveComponent("icon-user")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_icon_apps = _resolveComponent("icon-apps")!
  const _component_icon_book = _resolveComponent("icon-book")!
  const _component_icon_bookmark = _resolveComponent("icon-bookmark")!
  const _component_icon_bar_chart = _resolveComponent("icon-bar-chart")!
  const _component_icon_bug = _resolveComponent("icon-bug")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_IconCaretRight = _resolveComponent("IconCaretRight")!
  const _component_IconCaretLeft = _resolveComponent("IconCaretLeft")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(GlobalHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, { class: "layout-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_sider, {
            collapsible: "",
            breakpoint: "xl"
          }, {
            trigger: _withCtx(({ collapsed }) => [
              collapsed
                ? (_openBlock(), _createBlock(_component_IconCaretRight, { key: 0 }))
                : (_openBlock(), _createBlock(_component_IconCaretLeft, { key: 1 }))
            ]),
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_a_menu, {
                "default-open-keys": ['/admin/user'],
                "default-selected-keys": ['/admin/user'],
                style: { width: '100%' },
                onMenuItemClick: onClickMenuItem,
                breakpoint: "xl"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_sub_menu, { key: "/admin/user" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_user),
                      _createTextVNode(" 用户管理 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "/admin/user" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("用户管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_sub_menu, { key: "/admin/app" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_apps),
                      _createTextVNode(" 问答管理 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "/admin/app" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("应用管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/question" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("问题管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/scoringResult" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("评分结果管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/userAnswer" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("用户答案管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_sub_menu, { key: "/admin/interview" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_book),
                      _createTextVNode(" 面试题管理 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "/admin/interview" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("面试题管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/interviewQuestionBank" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("题库管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/interviewQuestionBankQuestion" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("面试题库关联表管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_sub_menu, { key: "/admin/post" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_bookmark),
                      _createTextVNode(" 帖子管理 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "/admin/post" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("帖子管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/comment" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("评论管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_sub_menu, { key: "/admin/appStatistic" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_bar_chart),
                      _createTextVNode(" 统计管理 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "/admin/appStatistic" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("应用统计")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "/admin/hotInterviewQuestionHot" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode("热门题目统计")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_sub_menu, { key: "/admin/bug" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_bug),
                      _createTextVNode(" BUG管理 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "/admin/bug" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" BUG管理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_header, { style: {"padding-left":"20px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_breadcrumb, { style: { margin: '16px 0' } }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hostPath.value.split('/'), (path) => {
                        return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: path }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(path), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_layout, { style: {"padding":"24px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_layout_content, { style: {"padding":"20px","border-radius":"20px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_layout_footer, { class: "footer" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_link, null, {
                        default: _withCtx(() => [
                          _createTextVNode("易答 By FYX")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})